import { render } from "./OptionForm.vue?vue&type=template&id=34aa2b98&scoped=true"
import script from "./OptionForm.vue?vue&type=script&lang=js"
export * from "./OptionForm.vue?vue&type=script&lang=js"

import "./OptionForm.vue?vue&type=style&index=0&id=34aa2b98&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34aa2b98"]])

export default __exports__